import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fa7ee4ba")

_pushScopeId("data-v-fa7ee4ba")
const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = { class: "row edit-row" }
const _hoisted_3 = { class: "editing-title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "row edit-row" }
const _hoisted_8 = { class: "editing-wrapper" }
const _hoisted_9 = { class: "content-row" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = { class: "product-title" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = { class: "content-row" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "product-title" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { class: "product-title" }
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "qty-content" }
const _hoisted_22 = {
  class: "cbx2",
  for: "Limited",
  tabindex: "12"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("circle", {
      class: "radio-circle",
      cx: "6",
      cy: "5",
      r: "2",
      fill: "white",
      stroke: "white",
      "stroke-width": "2"
    })
  ])
], -1)
const _hoisted_24 = { class: "checkboxtext" }
const _hoisted_25 = {
  class: "qty-input",
  style: {"padding-left":"4px"}
}
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-question fs-20" }, null, -1)
const _hoisted_27 = { class: "col-12" }
const _hoisted_28 = {
  class: "cbx2",
  for: "Unlimited",
  tabindex: "12"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("circle", {
      class: "radio-circle",
      cx: "6",
      cy: "5",
      r: "2",
      fill: "white",
      stroke: "white",
      "stroke-width": "2"
    })
  ])
], -1)
const _hoisted_30 = { class: "checkboxtext" }
const _hoisted_31 = { class: "row edit-row popup-two-buttons" }
const _hoisted_32 = { class: "col-12" }
const _hoisted_33 = {
  class: "save-button-wrapper popup-bookit-button w-100",
  type: "submit"
}
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = {
  key: 1,
  class: "row edit-row"
}
const _hoisted_36 = { class: "editing-wrapper text-center" }
const _hoisted_37 = { class: "step-form-title lh18 no-opacity p-2" }
const _hoisted_38 = { class: "pointer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputMask = _resolveComponent("InputMask")

  return (_openBlock(), _createBlock("form", {
    onSubmit: _cache[12] || (_cache[12] = _withModifiers(($event: any) => ($setup.submitForm($event)), ["prevent"])),
    class: "container popup-container",
    id: "create-time-duration",
    novalidate: ""
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          ($setup.timeSlot.id)
            ? (_openBlock(), _createBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('duration.editTheSlot')), 1))
            : (_openBlock(), _createBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('duration.createANewSlot')), 1))
        ])
      ]),
      _createVNode(_Transition, { name: "help" }, {
        default: _withId(() => [
          ($setup.showHelp)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _createVNode("div", _hoisted_10, [
                        _createVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('duration.startTime')), 1)
                      ]),
                      _createVNode("div", _hoisted_12, [
                        _createVNode(_component_InputMask, {
                          type: "text",
                          class: "form-control h-auto bookit-input product-input",
                          input: $setup.validateDate('start'),
                          mask: "99:99",
                          placeholder: "09:00",
                          required: "",
                          autoClear: false,
                          modelValue: $setup.timeSlot.startTime,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.timeSlot.startTime = $event)),
                          onBlur: _cache[2] || (_cache[2] = ($event: any) => (
                                            $setup.timeSlot.startTime =
                                                $setup.timeSlot.startTime != '__:__' ? $setup.timeSlot.startTime.replaceAll('_', '0') : ''
                                        ))
                        }, null, 8, ["input", "modelValue"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, [
                        _createVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('duration.duration')), 1)
                      ]),
                      _createVNode("div", _hoisted_16, [
                        _createVNode(_component_InputMask, {
                          type: "text",
                          class: "form-control h-auto bookit-input product-input",
                          input: $setup.validateDate('duration'),
                          mask: "99:99",
                          placeholder: "hh:mm",
                          required: "",
                          autoClear: false,
                          modelValue: $setup.timeSlot.duration,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.timeSlot.duration = $event)),
                          onBlur: _cache[4] || (_cache[4] = ($event: any) => (
                                            $setup.timeSlot.duration = $setup.timeSlot.duration != '__:__' ? $setup.timeSlot.duration.replaceAll('_', '0') : ''
                                        ))
                        }, null, 8, ["input", "modelValue"])
                      ])
                    ]),
                    _createVNode("div", null, [
                      _createVNode("div", _hoisted_17, [
                        _createVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('duration.isThereAQTYLimit')), 1)
                      ]),
                      _createVNode("div", _hoisted_19, [
                        _createVNode("div", _hoisted_20, [
                          _createVNode("span", _hoisted_21, [
                            _createVNode("input", {
                              class: "inp-cbx2 form-control",
                              name: "salePerDay",
                              type: "radio",
                              style: {"display":"none"},
                              id: "Limited",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.timeSlot.quantity = 0)),
                              checked: $setup.timeSlot.quantity != null
                            }, null, 8, ["checked"]),
                            _createVNode("label", _hoisted_22, [
                              _hoisted_23,
                              _createVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('duration.limited')), 1)
                            ])
                          ]),
                          _createVNode("span", _hoisted_25, [
                            _withDirectives(_createVNode("input", {
                              type: "number",
                              class: "bookit-input product-input form-control d-inline",
                              disabled: $setup.timeSlot.quantity == null,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ($setup.timeSlot.quantity = $event)),
                              min: "1",
                              onFocus: _cache[7] || (_cache[7] = ($event: any) => ($setup.timeSlot.quantity = $setup.timeSlot.quantity == 0 ? '' : $setup.timeSlot.quantity)),
                              required: ""
                            }, null, 40, ["disabled"]), [
                              [_vModelText, $setup.timeSlot.quantity]
                            ]),
                            _createVNode("span", {
                              onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.showHelp = !$setup.showHelp)),
                              class: "pointer"
                            }, [
                              _hoisted_26
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_27, [
                        _createVNode("input", {
                          class: "inp-cbx2",
                          name: "salePerDay",
                          type: "radio",
                          style: {"display":"none"},
                          id: "Unlimited",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.timeSlot.quantity = null)),
                          checked: $setup.timeSlot.quantity == null
                        }, null, 8, ["checked"]),
                        _createVNode("label", _hoisted_28, [
                          _hoisted_29,
                          _createVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('duration.unlimited')), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_31, [
                  _createVNode("div", _hoisted_32, [
                    _createVNode("button", _hoisted_33, _toDisplayString(_ctx.$t('button.save')), 1)
                  ]),
                  _createVNode("div", _hoisted_34, [
                    _createVNode("button", {
                      class: "close-button-wrapper popup-bookit-button w-100",
                      type: "button",
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.close && $setup.close(...args)))
                    }, _toDisplayString(_ctx.$t('button.close')), 1)
                  ])
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_35, [
                _createVNode("div", _hoisted_36, [
                  _createVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('help.aboutLimited')), 1),
                  _createVNode("span", null, [
                    _createVNode("div", _hoisted_38, [
                      _createVNode("i", {
                        onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.showHelp = !$setup.showHelp)),
                        class: "icon-f icon-arrow-back fs-28"
                      })
                    ])
                  ])
                ])
              ]))
        ]),
        _: 1
      })
    ])
  ], 32))
})